import { Example } from "./Example";

import styles from "./Example.module.css";

export type ExampleModel = {
    text: string;
    value: string;
};

const EXAMPLES: ExampleModel[] = [
    {
        text: "How to claim LLP Fund and Flexpro?",
        value: "How to claim LLP Fund and Flexpro?",
    },
    {
        text: "What is our CX Commitments?",
        value: "What is our CX Commitments?",
    },
    {
        text: "Bagaimana prosedur leave request and approval?",
        value: "Bagaimana prosedur leave request and approval?"
    }
];

interface Props {
    onExampleClicked: (value: string) => void;
}

export const ExampleList = ({ onExampleClicked }: Props) => {
    return (
        <ul className={styles.examplesNavList}>
            {EXAMPLES.map((x, i) => (
                <li key={i}>
                    <Example text={x.text} value={x.value} onClick={onExampleClicked} />
                </li>
            ))}
        </ul>
    );
};
